import { Route, Routes } from 'react-router-dom';
import React, { Suspense } from "react";
import Docs from '../../../views/Docs/Docs';

const Documentacion = () => {
    return (
        <Routes>
            <Route exact path="/docs"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <Docs></Docs>
                       </Suspense>
                   }>
            </Route>
            
        </Routes>
    )
}

export default Documentacion
